import { Cell, styled } from '@zeiss/beyond-online-react';

export const SectionActionCell: typeof Cell.Basic = styled(Cell.Basic)`
  align-self: center;

  & > button {
    padding-inline-start: 0;
  }
`;
